/* __next_internal_client_entry_do_not_use__ MutedBrandInsightsTileContents auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { AnnouncementMuted } from "@faire/web--source/slate/icons/foundation/Announcement";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var MutedBrandInsightsTileContents = /*#__PURE__*/ React.memo(function(param) {
    var brandName = param.brandName, onUndoMuteClick = param.onUndoMuteClick;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx(AnnouncementMuted, {
                fontSize: "24px"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "cc+c46",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Updates muted"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "vQOqa4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You\u2019ll no longer get updates from "
                        },
                        {
                            type: 8,
                            value: "MediumFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "brandCompanyName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: {
                        brandCompanyName: brandName,
                        MediumFormatting: MediumFormatting
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                onClick: onUndoMuteClick,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "/T1noR",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Undo"
                        }
                    ]
                })
            })
        ]
    });
});
